module.exports = new __parcel__URL__("get-design-updates.77503f6c.png").toString();